import { Link } from 'react-router-dom';

interface EmptyStateProps {
  message: string;
  actionLabel?: string;
  actionTo?: string;
  actionOnClick?: () => void;
  className?: string;
}

export function EmptyState({
  message,
  actionLabel,
  actionTo,
  actionOnClick,
  className = '',
}: EmptyStateProps) {
  const actionButton = actionLabel && (
    actionTo ? (
      <Link
        to={actionTo}
        className="inline-block px-5 py-2.5 bg-[color:var(--nt-primary)] text-white rounded-xl font-medium hover:brightness-95 transition-all duration-200"
      >
        {actionLabel}
      </Link>
    ) : actionOnClick ? (
      <button
        onClick={actionOnClick}
        className="inline-block px-5 py-2.5 bg-[color:var(--nt-primary)] text-white rounded-xl font-medium hover:brightness-95 transition-all duration-200"
      >
        {actionLabel}
      </button>
    ) : null
  );

  return (
    <div className={`w-full text-center py-12 ${className}`}>
      <p className="theme-text-muted mb-4">{message}</p>
      {actionButton}
    </div>
  );
}
